export const sidebarWidth = 350;
export const toggleWidth = 25;
export const hitsPerPage = 12;
